module.exports = "/_next/static/images/dwp-x-monstore_light-75238fd574d932551d2e1443361e9a33.png";